import { Inject, Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IDataService, IParsedDataResponse } from '../../data/data-service.interface';
import { RbacServiceInterface } from '../../rbac/rbac-service.interface';
import { ActionConfigInterface, Group, IHint, IHints } from '../interfaces/action-config.interface';
import { FieldModel } from '../models/field.model';

@Injectable()
export abstract class ActionConfigAbstract implements ActionConfigInterface {
  protected abstract readonly key: string;
  protected abstract readonly repository: string;
  protected abstract readonly title: string;
  protected abstract readonly description: string;
  protected readonly editTitle: string;
  protected readonly editDescription: string;
  protected abstract readonly fields: FieldModel[];
  protected readonly modalStyle: string = '-medium';
  protected readonly gridFields: number[] = [];
  protected readonly tooltipsFields: object = {};
  protected readonly btnCaption: string = $localize`:@@common.submit:Submit`;
  protected readonly customValidator: any;
  protected readonly groups: Group[];
  protected readonly dependHideFields: Record<string, Observable<boolean>> = {};
  protected readonly hints: IHints = {};
  protected readonly bodyText: string;

  constructor(
    @Inject('IDataService') protected readonly dataService: IDataService,
    @Inject('RbacServiceInterface') protected readonly rbacService: RbacServiceInterface
  ) {}

  protected get globalData(): IParsedDataResponse {
    return this.dataService.getData();
  }

  getKey(): string {
    return this.key;
  }

  getData(): string {
    return this.repository;
  }

  getTitle(): string {
    return this.title;
  }

  getDescription(): string {
    return this.description;
  }

  getEditTitle(): string {
    return this.editTitle;
  }

  getEditDescription(): string {
    return this.editDescription;
  }

  getFields(): FieldModel[] {
    return this.fields
      .filter(({ key }) => !key.includes('[toggle]'))
      .filter(({ permission }) => (permission ? this.rbacService.can(permission) : true));
  }

  getModalStyle(): string {
    return this.modalStyle;
  }

  getGrid(): number[] {
    return this.gridFields;
  }

  getTooltipsFields(): object {
    return this.tooltipsFields;
  }

  getBtnCaption(): string {
    return this.btnCaption;
  }

  getCustomValidator(): string {
    return this.customValidator;
  }

  getGroup(): Group[] | null {
    return this.groups ?? null;
  }

  getToggleField(): FieldModel | null {
    let toggleField = this.fields.find(({ key }) => key.includes('[toggle]')) ?? null;
    if (toggleField) {
      toggleField = new FieldModel(
        toggleField.label,
        toggleField.key,
        toggleField.component,
        toggleField.formControl,
        toggleField.settings
      );
      toggleField.key = toggleField.key.replace('[toggle]', '');
    }
    return toggleField;
  }

  formHandlerOnInit(form: UntypedFormGroup): void;
  formHandlerOnInit(): void {}

  formHandlerOnSubmit(form: UntypedFormGroup): void;
  formHandlerOnSubmit(): void {}

  getDependHideFields(): Record<string, Observable<boolean>> {
    return this.dependHideFields;
  }

  getHint(key: string): IHint | null {
    return this.hints[key] || null;
  }

  getBodyText(): string | null {
    return this.bodyText || null;
  }
}
